module.exports = __webpack_public_path__ + "static/media/control-vs-acceptance-large.3d0ebb53.png";